const normalizeCharacter = (character) => (/\s|\u00a0/.test(character) ? ' ' : character.toLowerCase());

const flattenDocumentText = (doc) => {
    let text = '';
    const positions = [];
    let previousEnd = null;
    let previousWasWhitespace = false;

    doc.descendants((node, position) => {
        if (!node.isText || !node.text) return;

        if (previousEnd != null && position > previousEnd && !previousWasWhitespace) {
            text += ' ';
            positions.push(null);
            previousWasWhitespace = true;
        }

        for (let index = 0; index < node.text.length; index += 1) {
            const character = node.text[index];
            const normalized = normalizeCharacter(character);
            if (normalized === ' ' && previousWasWhitespace) continue;
            text += normalized;
            positions.push(position + index);
            previousWasWhitespace = normalized === ' ';
        }
        previousEnd = position + node.nodeSize;
    });

    return { text, positions };
};

const normalizeSearchText = (value) =>
    String(value || '')
        .toLowerCase()
        .replace(/[\s\u00a0]+/g, ' ')
        .trim();

const findOccurrences = (text, searchText) => {
    const starts = [];
    let from = 0;

    while (from <= text.length - searchText.length) {
        const start = text.indexOf(searchText, from);
        if (start === -1) break;
        starts.push(start);
        from = start + Math.max(searchText.length, 1);
    }

    return starts;
};

export const findRichTextHighlightRanges = (doc, highlights = []) => {
    const { text, positions } = flattenDocumentText(doc);

    return highlights.flatMap(({ id, index, value }) => {
        const searchText = normalizeSearchText(value);
        if (!searchText) return [];

        const occurrences = findOccurrences(text, searchText);
        const selectedOccurrences =
            Number.isInteger(index) && index >= 0 ? occurrences.slice(index, index + 1) : occurrences;

        return selectedOccurrences.flatMap((start) => {
            const end = start + searchText.length;
            const matchedPositions = positions.slice(start, end).filter((position) => position != null);
            if (!matchedPositions.length) return [];

            return [
                {
                    id,
                    from: matchedPositions[0],
                    to: matchedPositions[matchedPositions.length - 1] + 1,
                },
            ];
        });
    });
};
